import React from 'react'
import { DOWNLOAD_IOS_APP } from '../../views/const'
import attention from "../../assets/images/attention.gif";

function HeaderMenu({home, login, signup, loginfromuser, registerfromuser}) {
 
    return (
        <div className="header-menu login-header-menu">
            <ul>
                <li className={home && "active"}><a href={loginfromuser || registerfromuser ? "/" : "/dashboard"}>Home</a></li>
                <li className={signup && "active"}><a href={loginfromuser || registerfromuser ? "/user-role" : "/user-role"}>Sign Up</a></li>
                <li><a href="/#contactus">Contact Us</a></li>
                <li className={login && "active"}><a href={loginfromuser || registerfromuser ? "/user-login" : "/login"}>Login</a></li>
                <li className="down"><a href={DOWNLOAD_IOS_APP}><b>Download App</b></a></li>
            </ul>
            <br />
                  <div
    style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        marginBottom: "20px",
        padding: "12px",
        backgroundColor: "#f5f9ff",
        border: "1px solid #d6e4ff",
        borderRadius: "6px"
    }}
>
    {/* Left Attention Icon */}
    <img
        src={attention}
        alt="Attention"
        style={{ width: "80px", height: "80px", flexShrink: 0 }}
    />

    {/* Center Links */}
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "5px"
        }}
    >
        <a
            href="/healthierpathconsentform"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                color: "#0078d4",
                fontWeight: "600",
                fontSize: "12px",
                textDecoration: "none"
            }}
        >
            Healthier Path Forward Participant Intake Form
        </a>

        <a
            href="/mentalhealthassessment"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                color: "#0078d4",
                fontWeight: "600",
                fontSize: "12px",
                textDecoration: "none"
            }}
        >
            Patient Health Questionnaire
        </a>
                <a
            href="/gad2"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                color: "#0078d4",
                fontWeight: "600",
                fontSize: "12px",
                textDecoration: "none"
            }}
        >
            General Anxiety Disorder
        </a>
        <a
            href="/healthierpathquizform"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                color: "#0078d4",
                fontWeight: "600",
                fontSize: "12px",
                textDecoration: "none"
            }}
        >
            Nutrition Assessment Form
        </a>
    </div>

    {/* Right Attention Icon */}
    <img
        src={attention}
        alt="Attention"
        style={{ width: "80px", height: "80px", flexShrink: 0 }}
    />
</div>


        </div>
    )
}

export default HeaderMenu;